namespace GeniuzPOS.Member {
    export interface PsMeberStatusRow {
        Id?: number;
        MbCardStatus?: string;
        MbCardStatuName?: string;
    }

    export namespace PsMeberStatusRow {
        export const idProperty = 'MbCardStatus';
        export const nameProperty = 'MbCardStatuName';
        export const localTextPrefix = 'Member.PsMeberStatus';
        export const lookupKey = 'Member.PsMeberStatus';

        export function getLookup(): Q.Lookup<PsMeberStatusRow> {
            return Q.getLookup<PsMeberStatusRow>('Member.PsMeberStatus');
        }
        export const deletePermission = '3Member:สมาชิก:Delete';
        export const insertPermission = '3Member:สมาชิก:Modify';
        export const readPermission = '3Member:สมาชิก:View';
        export const updatePermission = '3Member:สมาชิก:Modify';

        export declare const enum Fields {
            Id = "Id",
            MbCardStatus = "MbCardStatus",
            MbCardStatuName = "MbCardStatuName"
        }
    }
}
